import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlTm } from 'src/app/common';
import { Team } from 'src/app/models/survey/team';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get(`${urlTm}/get-all`);
  }

  getOne(id: string) {
    return this.http.get(`${urlTm}/get-one/${id}`);
  }

  create(data: Team): Observable<Team> {
    return this.http.post(`${urlTm}/create`, data);
  }

  update(id: string, data: Team): Observable<Team> {
    return this.http.put(`${urlTm}/update/${id}`, data);
  }

  delete(id: string) {
    return this.http.delete(`${urlTm}/delete/${id}`);
  }

}
